import type { Order } from '@billx/types';

export type MessageHandler = (payload: unknown) => void;

export type SubscribeArgs = {
  event: string;
  handler: MessageHandler;
};

// WebSocket Room Types
export const WS_ROOM_TYPES = {
  OUTLET: 'outlet',
  ORDER: 'order',
} as const;

export type WsRoomType = (typeof WS_ROOM_TYPES)[keyof typeof WS_ROOM_TYPES];

// Room join/leave message types
export const WS_ROOM_ACTIONS = {
  [WS_ROOM_TYPES.OUTLET]: {
    join: 'joinOutlet',
    leave: 'leaveOutlet',
    idKey: 'outletId',
  },
  [WS_ROOM_TYPES.ORDER]: {
    join: 'joinOrder',
    leave: 'leaveOrder',
    idKey: 'orderId',
  },
} as const;

// Helper to build room key
export const buildRoomKey = (type: WsRoomType, id: string) => `${type}:${id}`;

interface WebsocketEvent<T> {
  data: T;
  timestamp: string;
}

export interface WebsocketErrorEvent {
  message: string;
}

export type OrderCreatedEvent = WebsocketEvent<Order>;

export type OrderUpdatedEvent = WebsocketEvent<Order>;

export type OrderDeletedEvent = WebsocketEvent<string>;

export type AccessTokenRefreshedEvent = WebsocketEvent<{
  accessToken: string;
  refreshToken: string;
}>;

export const WS_NAMESPACES = {
  ORDERS: 'orders',
};

export const WS_EVENTS = {
  CONNECTED: 'connect',
  DISCONNECTED: 'disconnect',
  ROOM: {
    JOINED: 'joined',
    LEFT: 'left',
  },
  ORDER: {
    CREATED: 'order:created',
    UPDATED: 'order:updated',
    DELETED: 'order:deleted',
  },
  ACCESS_TOKEN: {
    REFRESHED: 'token:refreshed',
  },
};
